export default "__VITE_PUBLIC_ASSET__726d0054__"